import { render, staticRenderFns } from "./DonutSatisfactionComponent.vue?vue&type=template&id=82b4742a"
import script from "./DonutSatisfactionComponent.vue?vue&type=script&lang=js"
export * from "./DonutSatisfactionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports